<template>
    <div id="app" :style="css">
        <Notifications />
        <router-view v-if="!appLoading" />
        <transition name="fade">
            <WarningPopup
                @close="closeWarning"
                :acceptButton="warning.acceptButton"
                :declineButton="warning.declineButton"
                @accept="warning.accept"
                @decline="warning.decline"
                type="warning"
                :title="$t('LABEL_WARNING')"
                :message="warning.message"
                :response="warning.response"
                v-if="warning.display"
            />
            <AppLoading v-if="appLoading" />
        </transition>
    </div>
</template>
<script>
import globalStyles from '@/helpers/globalStyles.js'
export default {
    components: {
        Notifications: () => import('./components/utils/Notifications'),
        AppLoading: () => import('./components/utils/AppLoading')
    },
    data() {
        return {
            appLoading: true
        }
    },
    computed: {
        css() {
            return globalStyles
        },
        currentUser() {
            return this.$store.state.user
        },
        warning() {
            return this.$store.state.warning
        }
    },
    methods: {
        async loadContent() {
            try {
                await this.$store.dispatch('content/getContent')
                this.appLoading = false
            } catch (error) {
                this.appLoading = false
                this.$Network.handleError(error)
                this.$router.push('/vod/status/unknown_error')
            }
        },
        closeWarning() {
            this.warning.cancel
                ? this.warning.cancel()
                : this.$store.commit('hideWarning')
        }
    },
    watch: {
        currentUser() {
            this.loadContent()
        }
    },
    mounted() {
        this.$i18n.locale = 'pl'
        this.loadContent()
    }
}
</script>
<style lang="scss">
@font-face {
    font-family: 'SofiaProLight';
    src: url(/SofiaProLight.woff) format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'SofiaProRegular';
    src: url(/SofiaProRegular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'SofiaProMedium';
    src: url(/SofiaProMedium.woff) format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'SofiaProSemiBold';
    src: url(/SofiaProSemiBold.woff) format('woff');
    font-weight: normal;
    font-style: normal;
}
.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.15s;
    transition-property: opacity;
    transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
@keyframes pulse {
    0% {
        transform: scale(1);
    }
    80% {
        transform: scale(1.05);
    }
}
a {
    text-decoration: none;
}
i {
    user-select: none;
}
* {
    box-sizing: border-box;
    &:focus {
        outline: none;
    }
}
html,
body {
    margin: 0;
    height: 100%;
    width: auto;
    position: device-fixed;
    overflow-x: hidden;
    max-width: 100%;
    font-size: calc(0.4em + 0.5vw);

    @media (max-width: 1000px) {
        font-size: calc(0.5em + 1.2vw);
    }
}
button {
    border: none;
    cursor: pointer;
    outline: none;
}
#app {
    font-family: 'SofiaProLight', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    background: var(--background);
    color: var(--color);

    a {
        color: var(--color);
        text-decoration: underline;
    }
}
.vod-view {
    height: 100vh;
    max-height: 100vh;
    width: 100vw;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: $medium;
    scroll-behavior: smooth;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}
::-webkit-scrollbar {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    width: 2px;
    height: 2px;
}
.vod-view-content {
    height: 100%;
    width: 100%;
    flex: 1;
    padding: 5rem 15rem;
    overflow: hidden;
    display: flex;

    @media (max-width: 1000px) {
        padding: 3rem 0 0 0;
    }
}
.support-view-content {
    height: 100%;
    width: 100%;
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    display: flex;

    @media (max-width: 1000px) {
        padding: 3rem 0 0 0;
    }
}
.router-view-content {
    width: 100vw;
    height: 100;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    margin: 0 -15rem;
    margin-bottom: -5rem;
    padding: 0 15rem;
    padding-bottom: 1rem;
}
.vod-content {
    flex: 1;
}
@media (max-width: 1000px) {
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
}
.login-subtitle {
    margin-top: 0.2rem;
}
.login-form-overflow {
    width: 100%;
    height: 100%;
    padding: 4rem 8rem;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    max-height: 100%;
    z-index: 1000;

    @media (max-width: 1300px) {
        padding: 1rem 8rem;
    }
    @media (max-width: 1000px) {
        padding: 0;
    }
}
.login-form-button {
    margin-top: 1rem;
    text-align: center;
}
.login-form {
    display: flex;
    flex-direction: column;
    width: 30%;
    z-index: 1000;
    min-width: 300px;

    @media (max-width: 1000px) {
        overflow-y: auto;
        width: 100%;
        padding: 1.5rem;
        box-sizing: border-box;
    }
}
.login-logo {
    width: 100%;
    cursor: pointer;
}
.login-greeting {
    margin-top: 3rem;
    font-size: 2.1rem;
    font-family: 'SofiaProSemiBold';
}
.login-comment-action {
    margin-left: auto;
    margin-top: 0.7rem;
    cursor: pointer;
    transition: $ease;
    font-family: $input-family;
    font-size: 0.9rem;
    color: var(--color);

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-button {
    margin: 0 auto;
    color: $light-accent;
    padding: 0.3rem 1rem;
    border-radius: 5rem;
    cursor: pointer;
    font-size: 1.1rem;
    transition: $ease;
    user-select: none;
    font-family: $input-family;
    background: $action-accent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 2.5rem;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    max-width: 500px !important;
    width: 90%;

    @media (max-width: 1000px) {
        padding: 0.2rem 0.5rem;
        width: 80%;
    }

    &:last-of-type {
        margin-right: 0;
    }

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-actions-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    font-size: 0.9rem;
}
.login-action {
    cursor: pointer;
    transition: $ease;
    color: $input;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-border {
    width: 50%;
    margin: 2rem auto;
    border-bottom: 0.1rem solid $light;
}
.login-comment {
    color: var(--color);
    font-size: 0.95rem;
}
.login-type-box div {
    bottom: 1rem;
}
.login-checkbox {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    transition: $ease;
}
.login-checkbox span {
    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-checkbox-text {
    margin-left: 1rem;
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.gallery-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-auto-rows: 15rem;
    grid-gap: 1rem;

    @media (max-width: 1300px) {
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: 15rem;
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 15rem;
    }
}
.feature-view {
    height: 100%;
    max-height: 100%;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.feature-view-navigation {
    margin-top: 1rem;
    padding: 0 10vw;
    box-sizing: border-box;

    @media (max-width: 1300px) {
        padding: 0 2rem;
    }
    @media (max-width: 1000px) {
        padding: 0 1rem;
    }
}
.feature-view-content {
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    flex: 1;
    padding: 0 10vw;
    box-sizing: border-box;

    @media (max-width: 1300px) {
        padding: 0 2rem;
    }
    @media (max-width: 1000px) {
        padding: 0 1rem;
    }
    padding-bottom: 1rem;
}
.section-selector {
    position: relative;
    width: 100%;
    border: $input-border;
    border-radius: $small-radius;
    margin-right: 0.5rem;
    transition: $ease;
    font-size: 1.2rem;
    padding: 0.45rem 0;

    &.-success {
        border-color: $accent-green;
        background: rgba(46, 213, 116, 0.184);
    }
    &.-error {
        border-color: $accent-red;
        background: rgba(255, 71, 86, 0.212);
    }

    &.-disabled {
        color: $smoked !important;
        background: rgba(211, 211, 211, 0.281);
        pointer-events: none;
    }

    &.-focus {
        border-color: $main-accent;
    }
    input {
        padding: 0;
        margin: none;
        outline: none;
        width: 100%;
        height: 100%;
        font-size: 1.1rem;
        font-family: $input-family;
        transition: $ease;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        border: none;

        padding: 0 1rem;
        border-radius: $small-radius;
        margin-right: 0.5rem;
        background: transparent;

        &:focus {
            border-color: $accent-green;
        }

        &.-prefix {
            padding: 0 3rem 0 1rem;
        }

        &.-error {
            border-color: $accent-red;
            color: $accent-red;
            &::placeholder {
                color: rgb(150, 150, 150);
            }
        }
        &.-success {
            border-color: $accent-green;
        }

        &::placeholder {
            color: $input-placeholder;
        }
    }
}
.selector-container {
    height: 100%;
    transition: $ease;
    font-size: 1.1rem;
    font-family: $input-family;
    cursor: pointer;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    padding: 0 1rem;
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    border-radius: $small-radius;

    &.-list {
        padding: 0.5rem 0rem;
    }
}
.input-icon {
    height: 1.2rem;
    margin-right: 1rem;
    transition: $ease;
}
.payment-modal-content {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    z-index: $highest;

    &.-first {
        position: relative;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            min-height: 1.4rem;
            min-width: 2rem;
        }
    }

    &.-hidden {
        display: none;
    }
}
.payments-form-block {
    border-left: 0.2rem solid $border-accent;
    padding: 1rem 2rem;
    box-sizing: border-box;
    transition: $ease;

    &.-active {
        border-color: $accent-apple;
    }

    &.-first {
        padding-top: 0rem;
    }

    &.-last {
        border-color: transparent;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            left: -0.2rem;
            top: 0;
            min-height: 1.6rem;
            min-width: 0.2rem;
            background: $accent-apple;
        }
    }
}
.payments-form-question {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    font-family: $input-family;
    font-size: 1.2rem;

    &.-first {
        &::after {
            top: 0rem;
        }
    }
    &.-active {
        &::after {
            background: $accent-apple;
        }
    }

    &::after {
        content: '';
        position: absolute;
        left: -2rem;
        top: 0.4rem;
        min-height: 0.2rem;
        min-width: 1rem;
        background: $border-accent;
        transition: $ease;
    }
}
.payments-form-hint {
    margin-left: 0.5rem;
    margin-top: 0.1rem;
}
.payments-form-answer {
    cursor: pointer;
    padding: 0.6rem;
    box-sizing: border-box;
    margin-top: 0.6rem;
    transition: $ease;
    border: $list-border;
    border-radius: $minimal-radius;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    user-select: none;
    color: $input;
    position: relative;

    &.-selected {
        border-color: $accent-apple;
        background: lighten($accent-apple, 45%);
        font-family: $input-family;
        color: #333;
    }

    &:hover {
        border-color: $accent-blue;
    }
}
.answer-word {
    margin: 0 0.1rem;

    &.-var {
        color: $accent-blue;
        font-family: $input-family;
    }
}
.popup-actions {
    z-index: 4999;
}
.form-question-active {
    position: absolute;
    left: -3rem;
    top: 0;
    height: 1.8rem;
    width: 1.8rem;
    background: $accent-apple;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        font-size: 1rem;
    }
}
.text-button {
    color: $action-accent;
    font-family: $input-family;
    transition: $ease;
    cursor: pointer;

    &.-inactive {
        color: $smoked;
    }

    &:hover {
        transform: $translateY;
    }
}
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgb(184, 184, 184);
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: rgb(145, 145, 145);
}
.vod-video-placeholder {
    width: 100%;
    height: 100%;
    position: absolute;

    img {
        width: 100%;
        height: 100%;
    }
}
.vod-webinar-loading {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.vod-webinar-player {
    width: 100%;
    min-height: 20rem;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
}
.webinar-certificate-button {
    border: solid 0.1rem $accent-apple;
    padding: 0.5rem 1.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: $input-radius;
    font-family: $input-family;
    font-size: 1.2rem;
    margin-left: 1rem;
    transition: $ease;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        background: $accent-apple;
    }

    i {
        font-size: 2rem;
        margin-right: 0.5rem;
    }

    &.-disabled {
        pointer-events: none;
    }

    &.-blue {
        border-color: $accent-blue;

        &:hover {
            background: $accent-blue;
        }
    }
}
.webinar-button-subtitle {
    margin-top: 0.5rem;
    text-align: right;
    font-size: 0.9rem;
}

.webinar-button-title {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    font-family: $input-family;
}
@media (max-width: 1000px) {
    .vod-webinar-player {
        margin: 0 -2rem;
        margin-top: -1.5rem;
        width: 120%;
        max-width: none;
    }
}
.flex-row {
    display: flex;
    align-items: center;
}
</style>
